const state = {
  user_id: null,
  tel: null,
  localId: null,
  birthday: null,
  check_email: false
}

const mutations = {
  setId(state, id) {
    state.user_id = id
  },
  setTel(state, tel) {
    state.tel = tel
  },
  setBirthday(state, birthday) {
    state.birthday = birthday
  },
  setLocalId(state, localId) {
    state.localId = localId
  },
  setCheckEmail(state, checkEmailFlg) {
    state.check_email = checkEmailFlg
  },
  delete(state) {
    state.user_id = null
    state.tel = null
    state.localId = null
    state.check_email = false
    state.birthday = null
  }
}

const actions = {
  delete({commit}) {
    commit('delete')
  },
  updateId({commit}, status) {
    commit('setId', status)
  },
  updateTel({commit}, status) {
    commit('setTel', status)
  },
  updateBirthday({commit}, status) {
    commit('setBirthday', status)
  }
}

const getters = {
  getId(state) {
    return state.user_id
  },
  getTel(state) {
    return state.tel
  },
  getCheckEmail(state) {
    return state.check_email
  },
  getBirthday(state) {
    return state.birthday
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
